import React, { forwardRef } from 'react'
import { Select } from '@chakra-ui/react'

import { useValueAs } from './utils'

export const SelectSingle = forwardRef(
  (
    {
      value,
      onChange,
      valueAs,
      isLoading,
      isLoadingLabel = 'A carrgar...',
      isDisabled,
      placeholder,
      ...props
    },
    ref
  ) => {
    const transform = useValueAs({ value, onChange, valueAs, isEvent: true, nullValue: '' })

    return (
      <Select
        {...props}
        ref={ref}
        value={transform.value}
        onChange={transform.onChange}
        isDisabled={isDisabled || isLoading}
        placeholder={isLoading ? isLoadingLabel : placeholder}
      />
    )
  }
)

export default SelectSingle
